
export default {
  data() {
    return {
      list: [],
      type: "",
      pageSize: 15,
      page: 1,
      total: 0,
    };
  },
  head() {
    return {
      title: this.type_groups[this.activeIndex].name,
      meta: [
        {
          name: "keywords",
          content:
            this.type_groups[this.activeIndex].name +
            "-艺愿星艺考填报-艺术类志愿填报,志愿填报系统,志愿填报指南,一对一志愿填报,志愿填报,艺术生找大学,画室,美术培训",
        },
        {
          hid: "description",
          name: "description",
          content:
            this.type_groups[this.activeIndex].name +
            "-艺愿星艺考填报-艺术生怎么填报高考志愿-艺术生智能志愿填报系统-全国艺术类志愿填报系统-艺术生填报志愿的方法与步骤-艺术生填报志愿方法视频-艺考的专业-艺考是什么-美术艺考考什么-报考志愿表-艺考志愿填报名师一对一",
        },
      ],
    };
  },
  async asyncData({ app, query, params }) {
    let type = params.type;
    if (type && type.indexOf(".html")) {
      type = type.replace(/.html/g, "");
    }
    let type_groups = [
      {
        name: "艺考资讯",
        id: "1",
      },
      {
        name: "考试大纲",
        id: "2",
      },
      // {
      //   name: "招生简章",
      //   id: "3",
      // },

      {
        name: "统考简章",
        id: "5",
      },
      // {
      //   name: "省份政策",
      //   id: "7",
      // },
      // {
      //   name: "解读与指导",
      //   id: "8",
      // },
    ];
    let activeIndex = 0;
    let postparams = {
      page: 1,
      pageSize: 15,
    };
    let name = "";
    let page = 1;
    if (query.page) {
      page = parseInt(query.page);
      postparams["page"] = page;
    }
    if (params.name) {
      name = params.name;
      postparams["name"] = name;
    }
    type = type ? type : 1;
    if (type) {
      type_groups.map((item, index) => {
        if (item.id == type) {
          activeIndex = index;
          postparams["classify_id"] = item.id;
        }
      });
    }
    let [information_list] = await Promise.all([
      await app.$axios.$post(
        "/app/artapi.php?r=information.get_information_list",
        postparams
      ),
    ]);
    return {
      type,
      list: information_list.data,
      total: information_list.total,
      total1: information_list.total,
      page,
      name,
      activeIndex: parseInt(activeIndex),
      type_groups,
    };
  },
  watchQuery: ["page", "type"],
  methods: {
    handleSelect(index) {
      this.type = this.type_groups[index]["id"];
      this.page = 1;
      this.changeRouter();
    },
    changeRouter() {
      let { page, type } = this;
      // this.$router.replace({
      //   path: "/informationlist/" + type + ".html?page=" + page,
      // });
      window.location.href = "/informationlist/" + type + ".html?page=" + page;
    },
    // 每页条数
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.changeRouter();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.page = val;
      this.changeRouter();
    },
  },
};
